import {
  apiRequest,
  P3KlistCP3K,
} from "../../../../../services/adapters/kepegawaian/dokumenP3KService";


import {
  P3KDownloadDraftSK
}from "../../../../../services/adapters/kepegawaian/P3KService";

class DataTableRepository {
  fetchRowTable = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      P3KlistCP3K,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchDownloadDraftSK = async (query) => {
    return await apiRequest(
      "get",
      P3KDownloadDraftSK,
      {
        params: query,
      },
      true
    );
  };
}

export default DataTableRepository;
